/* eslint-disable no-magic-numbers */
import { scaleToFit } from './utils/scaleTo';
import { getRel, getRelX, getRelY } from './utils/getRel';
import { fontFamily } from './constants';

export default function ContestLogo(imgName, text, relFontSize, resources) {
	let logo;
	if (imgName) {
		// use the image for the logo
		logo = new PIXI.Sprite(resources[imgName].texture);
		scaleToFit(logo, getRelX(0.6), getRelY(0.6));
	} else {
		// no image create a text
		logo = new PIXI.Text(text, {
			fontWeight: 'normal',
			fontSize: relFontSize,
			fontFamily: fontFamily,
			fill: '#FFFFFF',
			align: 'center',
			wordWrap: true,
			wordWrapWidth: getRelX(0.5),
		});
		logo.scale.x = 2;
		logo.scale.y = 2;
	}
	logo.anchor = new PIXI.Point(0.5, 0.5);
	logo.position = getRel(0.5, 0.5);

	return logo;
}
